import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input,
    OnChanges,
    OnInit,
    Output,
    SimpleChanges,
  } from '@angular/core';
  import { SelectItem } from 'src/app/modules/shared/components/custom-select/select-item';
  
  @Component({
    selector: 'app-shows-month-select',
    templateUrl: './shows-month-select.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
  })
  export class ShowsMonthSelectComponent implements OnChanges {
    typeSelect: string = 'Mês: '
    @Input() active?: string;
    @Input() type = ''
    @Output() activeChange = new EventEmitter<string | undefined>();
  
    selected?: SelectItem<string | undefined>;
    status: SelectItem<string | undefined>[] = [
        { label: 'Todos', value: undefined},
        { label: 'JAN', value: '0'},
        { label: 'FEV', value: '1'},
        { label: 'MAR', value: '2'},
        { label: 'ABR', value: '3'},
        { label: 'MAI', value: '4'},
        { label: 'JUN', value: '5'},
        { label: 'JUL', value: '6'},
        { label: 'AGO', value: '7'},
        { label: 'SET', value: '8'},
        { label: 'OUT', value: '9'},
        { label: 'NOV', value: '10'},
        { label: 'DEZ', value: '11'}
    ]
  
    constructor() {}
  
    ngOnChanges(changes: SimpleChanges): void {
      if (changes.active) {
        this.selected = this.status?.find(
          (select) => select.value === this.active
        );
      }
    }
  
    change(selectedItem: SelectItem<string | undefined>): void {
        this.active =  selectedItem.value;
        this.selected = selectedItem;
        this.activeChange.emit(this.active);
    }
  }
  